import React from "react";
import QuestionLayout from "./QuestionLayout";

export default function LetteredTextInputs({config, value = {}, onChange, mode = "edit", feedback}) {
  const saved = value && typeof value === "object" && !Array.isArray(value) ? value : {};
  return <QuestionLayout number={config.number} prompt={config.prompt} points={config.points} mode={mode} feedback={feedback}>
    <div style={{width:"100%", maxWidth:config.imageWidth || 1100, color:"#1f2937"}}>
      {config.image && <img src={config.image} alt={config.imageAlt || "Question reference"}
        style={{display:"block",width:"100%",height:"auto",marginBottom:24}} />}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(min(100%, 220px), 1fr))",columnGap:28,rowGap:22,paddingBottom:8}}>
        {(config.rows || []).map(row => {
          const part = feedback?.parts?.find(p => p.id === row.id);
          const color = mode === "review" && typeof part?.correct === "boolean" ? (part.correct ? "#2e7d32" : "#c62828") : "currentColor";
          return <label key={row.id} style={{display:"flex",alignItems:"baseline",gap:8,minWidth:0}}>
            <span style={{fontSize:17,whiteSpace:"nowrap"}}>{row.label || row.id}.</span>
            <input type="text" aria-label={`Answer ${row.label || row.id}`} value={saved[row.id] || ""}
              disabled={mode !== "edit"} autoComplete="off" spellCheck={false}
              onChange={e => onChange({...saved,[row.id]:e.target.value})}
              style={{fontSize:17,padding:"6px 4px",width:"100%",minWidth:0,background:"transparent",color:"inherit",opacity:1,border:0,borderBottom:`2px solid ${color}`,borderRadius:0}} />
          </label>;
        })}
      </div>
    </div>
  </QuestionLayout>;
}
